import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=2a29bd54&scoped=true&"
import script from "./Issue.vue?vue&type=script&lang=ts&"
export * from "./Issue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29bd54",
  null
  
)

export default component.exports